'use strict';
var app = require('angular').module('directive.chipsUsersTags', []);

app.directive('chipsUsersTags', [require('./chipsUsersTagsDirective')]);
